export default "__VITE_ASSET__65350f53__"